import { render } from "./HighlightSection.vue?vue&type=template&id=2c937a8c"
import script from "./HighlightSection.vue?vue&type=script&lang=js"
export * from "./HighlightSection.vue?vue&type=script&lang=js"

import "./HighlightSection.vue?vue&type=style&index=0&id=2c937a8c&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__